import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  inject,
} from '@angular/core';
import {
  UntypedFormGroup,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { startWith, map } from 'rxjs/operators';
import { AdminService } from '../../admin.service';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-add-unit',
  templateUrl: './add-unit.component.html',
  styleUrls: ['./add-unit.component.scss'],
  imports: [
    MatSelectModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class AddUnitComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AddUnitComponent>>(MatDialogRef);
  private adminSrvc = inject(AdminService);

  @Input() unitData; // = ['Home Office', 'New Unit'];
  @ViewChild('unitInput', { static: false })
  unitInput: ElementRef<HTMLInputElement>;

  gridForm: FormGroup = null;
  unitCtrl = new FormControl();
  filteredUnits: Observable<string[]>;
  units = [];
  createRepcode = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  required = true;

  selectedUnit(event: MatAutocompleteSelectedEvent): void {
    this.units.push(event.option.viewValue);
    this.unitInput.nativeElement.value = '';
    this.unitCtrl.setValue(null);
  }

  constructor() {
    this.filteredUnits = this.unitCtrl.valueChanges.pipe(
      startWith(null),
      map((unit: string | null) =>
        unit ? this._filterItem(unit, this.unitData) : this.unitData.slice()
      )
    );

    const formGroup = {};
    formGroup['unitID'] = new FormControl();
    formGroup['unitName'] = new FormControl();
    formGroup['unitType'] = new FormControl();
    formGroup['parentUnit'] = new FormControl();
    // formGroup['roles'] = new FormControl()
    this.gridForm = new UntypedFormGroup(formGroup);
  }

  ngOnInit() {
    this.getExistingUnits();
  }

  save() {
    if (this.gridForm.valid) {
      const output = this.gridForm.value;

      output.parentUnit = this.units.find(x => x.name === output.parentUnit).id;
      output.newUnit = true;

      this.dialogRef.close({ data: this.gridForm.value });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }

  cancel() {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  addItem(
    event: MatChipInputEvent,
    items: Array<any>,
    control: FormControl
  ): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      items.push(value.trim());
    }

    if (input) {
      input.value = '';
    }

    control.setValue(null);
  }

  getExistingUnits() {
    this.adminSrvc.getUnitList(null, true).subscribe(x => {
      this.units = x.names;
    });
  }

  checkUnitId(event: Event) {
    const newId = event.target?.['value'];
    const duplicate = this.units.filter(x => x.id === newId).length > 0;

    if (duplicate) {
      this.gridForm.controls['unitID'].setErrors({ notUnique: true });
    } else {
      this.gridForm.controls['unitID'].setErrors(null);
    }
  }

  checkUnitName(event: Event) {
    const newName = event.target['value'];
    const duplicate = this.units.filter(x => x.name === newName).length > 0;

    if (duplicate) {
      this.gridForm.controls['unitName'].setErrors({ notUnique: true });
    } else {
      this.gridForm.controls['unitName'].setErrors(null);
    }
  }

  private _filterItem(value: string, items: Array<any>): string[] {
    const filterValue = value.toLowerCase();

    return items.filter(unit => unit.toLowerCase().indexOf(filterValue) === 0);
  }
}
